import React from "react";
import {useSelector} from "react-redux";

export default function PaySimpleTransactionFee({ paymentSourceKind }) {
  const { organization, paymentInfo } = useSelector(state => state)
  const { pay_simple_fees } = paymentInfo
  const organizations = pay_simple_fees.organizations || []
  const beaconOrganizations = pay_simple_fees.beacon_organizations || []
  const cardOnlyOrganizations = pay_simple_fees.card_only_organizations || []
  const shepherdInnDallasOrganizations = pay_simple_fees.shepherd_inn_dallas_organizations || []
  const shepherdInnOrganizations = pay_simple_fees.shepherd_inn_organizations || []
  const dynamicLifeOrganizations = pay_simple_fees.dynamic_life_organizations || []
  const consistentCareOrganizations = pay_simple_fees.consistent_care_organizations || []
  const standingByTheDoorOrganizations = pay_simple_fees.standing_by_the_door_organizations || []
  const newDaySoberLivingCardFees = pay_simple_fees.new_day_sober_living_card_fees || pay_simple_fees.fees['CARD']
  const standingByTheDoorCardFees = pay_simple_fees.standing_by_the_door_card_fees || pay_simple_fees.fees['CARD']
  const shepherdInnDallasFees = pay_simple_fees.shepherd_inn_dallas_fees || pay_simple_fees.fees
  const shepherdInnFees = pay_simple_fees.shepherd_inn_fees || pay_simple_fees.fees
  const dynamicLifeFees = pay_simple_fees.dynamic_life_fees || pay_simple_fees.fees
  const beaconFees = pay_simple_fees.beacon_fees || pay_simple_fees.fees
  const consistentCareFees = pay_simple_fees.consistent_care_fees || pay_simple_fees.fees

  const isPaySimpleOrg = () => {
    if (organization.payment_processor !== "paysimple") {
      return false
    }
    return (
      organizations.includes(organization.name) ||
      beaconOrganizations.includes(organization.name) ||
      cardOnlyOrganizations.includes(organization.name) ||
      shepherdInnDallasOrganizations.includes(organization.name) ||
      shepherdInnOrganizations.includes(organization.name) ||
      dynamicLifeOrganizations.includes(organization.name) ||
      consistentCareOrganizations.includes(organization.name) ||
      standingByTheDoorOrganizations.includes(organization.name)
    )
  }

  const isShepherdInnDallasOrg = shepherdInnDallasOrganizations.includes(organization.name)
  const isShepherdInnOrg = shepherdInnOrganizations.includes(organization.name)
  const isDynamicLifeOrg = dynamicLifeOrganizations.includes(organization.name)
  const isBeaconOrg = beaconOrganizations.includes(organization.name)
  const isConsistentCareOrg = consistentCareOrganizations.includes(organization.name)
  const isNewDayOrg = cardOnlyOrganizations.includes(organization.name)
  const isStandingByTheDoorOrg = standingByTheDoorOrganizations.includes(organization.name)
  const isCardOnlyOrg = isNewDayOrg || isStandingByTheDoorOrg
  const isCardPaymentSource = ['card', 'other_card'].includes(paymentSourceKind)

  const cardFees = isDynamicLifeOrg
    ? dynamicLifeFees['CARD']
    : isShepherdInnDallasOrg
    ? shepherdInnDallasFees['CARD']
    : isShepherdInnOrg
    ? shepherdInnFees['CARD']
    : isBeaconOrg
    ? beaconFees['CARD']
    : isConsistentCareOrg
    ? consistentCareFees['CARD']
    : isNewDayOrg
    ? newDaySoberLivingCardFees
    : isStandingByTheDoorOrg
    ? standingByTheDoorCardFees
    : pay_simple_fees.fees['CARD']

  const achFees = isDynamicLifeOrg
    ? dynamicLifeFees['BANK_ACCOUNT']
    : isShepherdInnDallasOrg
    ? shepherdInnDallasFees['BANK_ACCOUNT']
    : isShepherdInnOrg
    ? shepherdInnFees['BANK_ACCOUNT']
    : isBeaconOrg
    ? beaconFees['BANK_ACCOUNT']
    : isConsistentCareOrg
    ? consistentCareFees['BANK_ACCOUNT']
    : pay_simple_fees.fees['BANK_ACCOUNT']

  const formatFee = (value) => Number(value).toFixed(2)

  if (!isPaySimpleOrg()) {
    return null
  }

  if (isCardOnlyOrg && !isCardPaymentSource) {
    return null
  }

  return (
    <div className={'pb-2'}>
      <div className={'text-black font-weight-bold'}>
        {cardFees['PERCENTAGE'] * 100}% + ${formatFee(cardFees['FIXED'])} Convenience fee will be applied for credit card payments
      </div>
      {!isCardOnlyOrg && (
        <div className={'text-black font-weight-bold'}>
          {achFees['PERCENTAGE'] * 100}% + ${formatFee(achFees['FIXED'])} Convenience fee will be applied for ACH payments
        </div>
      )}
    </div>
  );
}
